import React, {useState} from 'react';
import Frame from "../components/layout/Frame";
import FrameV2 from "../components/layout/Frame";
import Container from "react-bootstrap/Container";
import {Col, Row} from "react-bootstrap";
import FacilityStatus from "./subPages/FacilityStatus";
import FailureCards from "./subPages/FailureCards";
import DashFailureCards from "./subPages/DashFailureCards";

const Dash = () => {

  const [stSectionID, setSectionID] = useState('0');

  return (
      <FrameV2
          propIsActiveHeader={false}
          propIsActiveSidebar={false}
      >
        <Container fluid className={"dash-container"}>
          <Row className={"p-3 h-100"}>
            <Col md={12}>
              <Row className={''}>
                <Col xl={8} className={"ps-0"}>
                  {/*시설 현황*/}
                  <FacilityStatus
                      // openLayerHandler={openLayerHandler}
                      // propInitState={propAuthInfo}
                      propAnonAPI={true}
                      propHomeSize={6}
                      stSectionID={stSectionID}
                      setSectionID={setSectionID}
                  />
                </Col>
                <Col xl={4} className={"ps-0"}>
                  {/* 장애 및 성능 */}
                  {/* 차트 변경 시 레이아웃 수정 필요*/}
                  {/*<FailureCards
                                    propAtdrcId={stSectionID}
                                    propAnonAPI={true}
                                />*/}
                  <DashFailureCards
                      propAtdrcId={stSectionID}
                      propAnonAPI={true}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </FrameV2>
  );
};

export default Dash;
